const VATReturns = () => {
  return (
    <ul>
      <li>
        We accept PDF statements downloaded from either{' '}
        <a
          href="https://www.tax.service.gov.uk/gg/sign-in?continue=/business-account/vat"
          target="_blank"
          rel="noreferrer"
        >
          the HMRC portal
        </a>{' '}
        or from your accounting software
      </li>
      <li>
        Need help? Check out our VAT return guide{' '}
        <a
          href="https://static.iwoca.com/pdf/vat_return_instructions.pdf"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
      </li>
    </ul>
  );
};

export default VATReturns;
